var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"project-title"},[_c('img',{staticClass:"project-icon",attrs:{"src":_vm.srcUrl,"alt":""}}),_vm._v(" "+_vm._s(this.currentProject.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }